import Message from './Message';

interface MessagesProps {
	msgs: any[],
	onRemoveMessage: any
}

const defaultProps = {
	msgs: [],
};

function Messages(propsIn: MessagesProps) {
	const props = {...defaultProps, ...propsIn};
	const style = {
		// On SP we don't want margin. We should make it adjustable to use somewhere else.
		// margin: '0 0 1em',
	};
	
	return (<div style={style}>
		{props.msgs.map((msg, index) => <Message key={index} message={msg} onRemoveMessage={props.onRemoveMessage}/>)}
	</div>);
}

export default Messages;
